import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电视剧分类", to: "/category/series" },
  { label: "剧集排行榜", to: "/ranking" },
  { label: "相关新闻", to: "/news" },
  { label: "关于我们", to: "/about" },
];

const hotTags = ["清河往事", "风月宝鉴", "市井风云", "演员资料", "剧情解析"];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50/15 text-lg text-accent-300">
                <i className="ri-book-2-line" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                金瓶梅<span className="text-accent-400">3</span> 影视大全
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-background-200/80">
              金瓶梅3影视大全致力于为影视爱好者提供金瓶梅系列相关影视作品的全集展示、剧情介绍、演员资料与更新动态，帮助您轻松了解剧情脉络与观看指南。
            </p>
            <p className="mt-4 max-w-md rounded-md border border-background-50/15 bg-background-50/5 px-4 py-3 text-xs leading-6 text-background-200/70">
              <i className="ri-information-line mr-1" />
              本站所有剧集、演员及新闻内容均为演示示例数据，真实数据接口待后续接入。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">
              <Link to="/" className="transition-colors hover:text-accent-300">
                站内导航
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-200/80 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">
              <Link to="/category/series" className="transition-colors hover:text-accent-300">
                热门标签
              </Link>
            </h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {hotTags.map((tag) => (
                <Link
                  key={tag}
                  to={`/category/series?q=${encodeURIComponent(tag)}`}
                  className="rounded-full border border-background-50/15 bg-background-50/5 px-3 py-1.5 text-xs text-background-200/80 transition-colors hover:border-accent-400/60 hover:text-accent-300"
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-200/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 金瓶梅3 影视大全 · 本站内容仅供影视资讯交流参考</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>免责声明：演示站点</span>
            <span className="hidden sm:inline">|</span>
            <span>数据均为示例内容</span>
          </p>
        </div>
      </div>
    </footer>
  );
}